
        require('./index.scss');
        'use strict';

var _banner = require('module/home-index/decoration/banner');

var _banner2 = _interopRequireDefault(_banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var $category = $('.index-page-decoration-module .nav-item-group').find('span');
var $content = $('.index-page-decoration-module .decor-content');
var _module = {
    topbanner: null,
    leftbanner: null,
    middlebanner: null,
    rightbanner: null,
    active: function active() {
        for (var i = 0; i < $category.length; i++) {
            if ($category.eq(i).hasClass('active')) {
                return i;
            }
        }
        return 0;
    },
    toggle: function toggle(actived) {
        this.topbanner && clearInterval(this.topbanner.timer);
        this.leftbanner && clearInterval(this.leftbanner.timer);
        this.middlebanner && clearInterval(this.middlebanner.timer);
        this.rightbanner && clearInterval(this.rightbanner.timer);

        var mod = $category.eq(actived);
        var url = mod.data('url');
        var suffix = mod.data('city');
        $('#cate').attr('href', url);

        var linkstitle = {
            input: mod.data('linkstitle-input'),
            // link: mod.data('linkstitle-link')
            link: '//' + suffix + '.' + 'home.focus.cn/zixun/C1202/'
        };
        var lefttitle = {
            input: mod.data('lefttitle-input'),
            link: mod.data('lefttitle-link')
        };
        var middletitle = {
            input: mod.data('middletitle-input'),
            link: mod.data('middletitle-link')
        };
        var righttitle = {
            input: mod.data('righttitle-input'),
            link: mod.data('righttitle-link')
        };
        var doms = ['.links', '.top', '.left', '.middle', '.right'];
        var links = [];
        var topbanner = [];
        var leftbanner = [];
        var middlebanner = [];
        var rightbanner = [];
        var data = [links, topbanner, leftbanner, middlebanner, rightbanner];
        for (var i = 0; i < doms.length; i++) {
            var dom = mod.find(doms[i]);
            for (var j = 0; j < dom.length; j++) {
                data[i].push({
                    link: dom.eq(j).data('link'),
                    img: dom.eq(j).data('img'),
                    input: dom.eq(j).data('input')
                });
            }
        }

        linkstitle && this.renderTitle('.links', linkstitle);
        lefttitle && this.renderTitle('.left-banner', lefttitle);
        middletitle && this.renderTitle('.middle-banner', middletitle);
        righttitle && this.renderTitle('.right-banner', righttitle);
        links.length && this.renderLink(data[0]);

        this.topbanner = topbanner && this.renderBanner('.wide-banner', data[1]);
        this.leftbanner = leftbanner && this.renderBanner('.left-banner', data[2]);
        this.middlebanner = middlebanner && this.renderBanner('.middle-banner', data[3]);
        this.rightbanner = rightbanner && this.renderBanner('.right-banner', data[4]);
    },
    renderTitle: function renderTitle(selector, titleInfo) {
        var mod = $(selector);
        var title = mod.find('h1 .title');
        var more = mod.find('h1 .more');
        if (titleInfo && titleInfo.input && titleInfo.link) {
            title.text(titleInfo.input);
            title.attr('href', titleInfo.link);
        }
        if (titleInfo && titleInfo.more) {
            more.attr('href', titleInfo.more);
        } else {
            more.attr('href', titleInfo.link);
        }
    },
    renderLink: function renderLink(linksInfo) {
        var link = $content.find('.links');
        var ul = link.find('ul');
        ul.empty();
        for (var i = 0; i < linksInfo.length; i++) {
            if (linksInfo[i] && linksInfo[i].input && linksInfo[i].link) {
                var li = $('<li><a target="_blank"></a></li>');
                li.find('a').text(linksInfo[i].input);
                li.find('a').attr('href', linksInfo[i].link);
                ul.append(li);
            }
        }
    },
    renderBanner: function renderBanner(selector, banners) {
        if (typeof selector == 'string') {
            var swiper = new _banner2['default']({
                'mod': selector,
                'ele': '.banner-list',
                'dotBtn': '.dots .dot',
                'rightBtn': '',
                'leftBtn': '',
                'banners': banners
            });
            swiper.init();
            return swiper;
        }
    },
    init: function init() {
        var that = this;
        var actived = this.active();
        $category.eq(actived).addClass('active');
        this.toggle(actived);
        $category.hover(function (e) {
            $category.removeClass('active');
            $(e.target).addClass('active');
            var actived = that.active();
            that.toggle(actived);
        });
        $category.click(function (e) {
            var target = $(e.target).data('url');
            window.open(target);
        });
    }
};

_module.init();
if (window.toggleCategory) {
    console.log('func name has been taken!');
} else {
    window.toggleCategory = _module.toggle;
};
    


// WEBPACK FOOTER //
// ./src/module/home-index/decoration/index.js